import { getFirstKeyData } from '@ch/common/utils/helpers';
import { getJson } from '../../get-json';

export const doMagicWithFile = (data: unknown) => {
  const loaded = getFirstKeyData(data);
  const subResult = Array.isArray(loaded) ? loaded : Object.values(loaded);

  return Array.isArray(subResult) ? subResult : Object.values(subResult);
};

export const loadFile = async (path: string) => {
  const acc = {};
  await getJson(`/${path}`, 'file', acc);

  return doMagicWithFile(acc['file']);
};

export const getFileExtension = (filename: string) => {
  const extension = /[.]/.exec(filename) ? /[^.]+$/.exec(filename) : undefined;
  return extension?.pop().toLowerCase();
};
